import { render, staticRenderFns } from "./WanStatusList.vue?vue&type=template&id=2f609e38&"
import script from "./WanStatusList.vue?vue&type=script&lang=js&"
export * from "./WanStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports